<template>
  <div class="invoices-table-sum-cell" v-if="params.invoice">
    <div class="invoices-table-sum-cell__content">
      <div class="invoices-table-sum-cell__info">
        <div class="invoices-table-sum-cell__sum">{{ +params.invoice.total_charge | numberWithSpaces }}</div>
        <div
          class="invoices-table-sum-cell__status"
          v-if="actualStatus && actualStatus.show"
          :style="{color: actualStatus.color}"
          :title="actualStatus.title"
        >
          <span data-high-contrast="font-bold">{{ actualStatus.name }}</span>
        </div>
      </div>
      <div class="invoices-table-sum-cell__buttons">
        <span
          @click.prevent.stop="pdfViewSupport ? openPdf() : null"
          v-if="link && pdfViewSupport"
        >
            <app-icon name="FileViewIcon" class="link-icon" />
        </span>
        <span @click.prevent="downloadInvoice" v-if="link">
            <app-icon name="DownloadFile" class="link-icon" />
        </span>
        <template v-if="showPopup">
          <vs-popup :active.sync="popupOpen" title="Просмотр квитанции" class="pdf-preview" v-if="link">
            <div :id="`pdf-preview-container-${_uid}`" class="pdf-container"></div>
          </vs-popup>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Vue       from 'vue';
import PDFObject from 'pdfobject';

const INVOICE_ACTUAL_STATUSES = {
  actual:    {
    name:  "актуальная",
    title: "Квитанция сгенерирована и не показана пользователю",
    color: "rgba(var(--app-warning), 1)",
    show:  true,
  },
  shown:     {
    name:  "показана",
    title: "Квитанция показана для пользователя",
    color: "rgba(var(--app-success), 1)",
    show:  true,
  },
  nonActual: {
    name:  "неактульная",
    title: "После генерации квитанций начисления изменились",
    color: "rgba(var(--app-danger), 1)",
    show:  true,
  },
  noLink:    {
    name:  "квитанции нет",
    title: "квитанции нет",
    color: "rgba(var(--app-text), 1)",
    show:  false,
  },
};

export default Vue.extend({
  name: "InvoiceInfo",
  data() {
    return {
      popupOpen: false,
      showPopup: false,
    };
  },
  computed: {
    link() {
      let { invoice: { anchor } } = this.params;
      if (!anchor) return null;
      if (anchor && anchor.charAt(0) === '/') {
        anchor = anchor.substr(1);
      }
      return anchor ? this.$options.filters.imgPath(anchor) : null;
    },
    pdfViewSupport() {
      return PDFObject.supportsPDFs;
    },
    actualStatus() {
      return this.getStatus(this.params.invoice);
    },
  },
  methods:  {
    downloadInvoice() {
      if (this.link === null) return false;
      let link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('href', this.link + '?v=' + Date.now());
      link.setAttribute('download', this.link.split('/').pop());
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    },

    openPdf() {
      if (this.pdfViewSupport) {
        this.showPopup = true;
        this.$nextTick(() => {
          PDFObject.embed(this.link + '?v=' + Date.now(), `#pdf-preview-container-${this._uid}`, {
            pdfOpenParams: {
              view:      'FitBH',
              scrollbar: 0,
              toolbar:   0,
            },
            height:        "100%",
          });
          this.popupOpen = true;
        });
      }
    },

    getStatus( invoice ) {
      let invoiceApartmentType = invoice.type_apart;
      let invoiceMonth = invoice.month;

      if (invoice.show_kv === true) {
        return INVOICE_ACTUAL_STATUSES.shown;
      }

      if (!invoice.anchor) {
        return INVOICE_ACTUAL_STATUSES.noLink;
      }

      if (!Array.isArray(this.params.chargeHistory) || !Array.isArray(this.params.invoicesHistory)) return null;

      let chargesHistory = this.params.chargeHistory.filter(history => {
        let log = history.log ? JSON.parse(history.log) : {};
        return log.month === invoiceMonth && (log.apartments_type === null || Number(log.apartments_type) === invoiceApartmentType);
      });

      let invoicesHistory = this.params.invoicesHistory.filter(history => {
        let log = history.log ? JSON.parse(history.log) : {};
        return log.month === invoiceMonth && (log.apartments_type === null || Number(log.apartments_type) === invoiceApartmentType);
      });

      if (chargesHistory.length && invoicesHistory.length) {
        let chargesHistoryItem = chargesHistory[0];
        let invoicesHistoryItem = invoicesHistory[0];

        let chargeDate = new Date(chargesHistoryItem.created_at);
        let invoiceDate = new Date(invoicesHistoryItem.created_at);

        if (chargeDate <= invoiceDate) {
          return INVOICE_ACTUAL_STATUSES.actual;
        } else {
          return INVOICE_ACTUAL_STATUSES.nonActual;
        }
      }
      return true;
    },
  },
  watch:    {
    popupOpen() {
      if (!this.popupOpen) {
        this.showPopup = false;
      }
    },
  },
});
</script>

<style lang="scss">
.pdf-preview {

  &.con-vs-popup {
    align-items: center;
  }

  .vs-popup {
    width: calc(100% - 30px);
    max-width: 650px;
    max-height: 900px;

    .vs-popup--content {
      overflow: unset;
      width: 100%;
      padding: 0;
      margin: 0;
    }
  }
}

.pdf-container {
  height: calc(100vh - 100px);
  max-height: 820px;
  width: 100%;
}

.invoices-table-sum-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  line-height: 1;

  &__content {
    display: flex;
    align-items: center;
  }

  &__info {
    min-width: 90px;
    text-align: center;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 50px;
  }

  &__status {
    margin-top: 2px;
    font-size: 11px;
    user-select: none;
  }
}
</style>
